module.exports = __webpack_public_path__ + "static/media/terms008.cf935f41.png";